export const DIM = {
    MOBILE: 414,
    LEFT_MARGIN: 20,
    TOP_MARGIN: 0, // ios?
    ICON_WIDTH: 112
}

export const COLORS = {
    // MAIN: '#f7f7f7',
    // MAIN: '#f2fafd',
    MAIN: '#f6faff',
    PURPLE: '#9052b1',
    GREEN: '#0d9c93',
    BLUE: '#548acc',
    GOLD: '#788a62',
    GRAY: '#778188'
}

export const TABLE_DIM = {
    NAME: 180,
    PRICE: 140,
    ARTICLE: 300,
    DB: 50,
    TELEGRAM: 50
}